<!-- ORCA-1945: menu "Ações" segmentado (enviar, visualizar, andamento, mais), com ícones e cores do design system -->
<mat-menu class="oa-actions-menu" xPosition="before">
    <div class="oa-am__section" role="presentation">Enviar ao cliente</div>
    <button id="enviar-por-whatsapp" [matMenuTriggerFor]="phoneMenu" mat-menu-item aria-label="Enviar por WhatsApp">
        <span class="oa-am__icon oa-am__icon--whatsapp" aria-hidden="true"><mat-icon>chat</mat-icon></span>
        <span>Enviar por WhatsApp</span>
    </button>
    <button id="enviar-por-email" *ngIf="proposal?.client?.email || proposal?.client?.contacts?.length"
        [matMenuTriggerFor]="contactsMenu" mat-menu-item aria-label="Enviar por e-mail">
        <span class="oa-am__icon oa-am__icon--email" aria-hidden="true"><mat-icon>mail</mat-icon></span>
        <span>Enviar por e-mail</span>
    </button>
    <button id="copiar-link" (click)="copy('link')" mat-menu-item aria-label="Copiar link do orçamento">
        <span class="oa-am__icon oa-am__icon--link" aria-hidden="true"><mat-icon>link</mat-icon></span>
        <span>Copiar link</span>
    </button>

    <mat-divider></mat-divider>
    <div class="oa-am__section" role="presentation">Visualizar</div>
    <button (click)="preview()" mat-menu-item aria-label="Visualizar orçamento">
        <span class="oa-am__icon oa-am__icon--view" aria-hidden="true"><mat-icon>pageview</mat-icon></span>
        <span>Visualizar orçamento</span>
    </button>
    <a *ngIf="clientPreviewUrl" [href]="clientPreviewUrl" target="_blank" rel="noopener" mat-menu-item
        aria-label="Visualizar como cliente (abre em outra aba)">
        <span class="oa-am__icon oa-am__icon--view" aria-hidden="true"><mat-icon>visibility</mat-icon></span>
        <span>Visualizar como cliente</span>
    </a>
    <button (click)="openPDF()" mat-menu-item aria-label="Gerar PDF">
        <span class="oa-am__icon oa-am__icon--pdf" aria-hidden="true"><mat-icon>picture_as_pdf</mat-icon></span>
        <span>Gerar PDF</span>
    </button>
    <button *ngIf="proposal?.cotacaoId" (click)="viewCotacao()" mat-menu-item aria-label="Ver cotação">
        <span class="oa-am__icon oa-am__icon--neutral" aria-hidden="true"><mat-icon>description</mat-icon></span>
        <span>Ver cotação</span>
    </button>

    <ng-container *ngIf="proposal?.canProcess || proposal?.status == 3 || proposal?.status == 5">
        <mat-divider></mat-divider>
        <div class="oa-am__section" role="presentation">Andamento</div>
        <button *ngIf="proposal?.canProcess" (click)="openActionDialog('aprovar')" mat-menu-item aria-label="Aprovar orçamento">
            <span class="oa-am__icon oa-am__icon--approve" aria-hidden="true"><mat-icon>thumb_up</mat-icon></span>
            <span>Aprovar</span>
        </button>
        <button *ngIf="proposal?.canProcess" (click)="openActionDialog('reprovar')" mat-menu-item aria-label="Reprovar orçamento">
            <span class="oa-am__icon oa-am__icon--refuse" aria-hidden="true"><mat-icon>thumb_down</mat-icon></span>
            <span>Reprovar</span>
        </button>
        <!-- const APROVED = 3 -->
        <button *ngIf="proposal?.status == 3" (click)="openActionDialog('faturar')" mat-menu-item aria-label="Faturar orçamento">
            <span class="oa-am__icon oa-am__icon--bill" aria-hidden="true"><mat-icon>receipt_long</mat-icon></span>
            <span>Faturar</span>
        </button>
        <!-- const BILLED = 5 -->
        <button *ngIf="proposal?.status == 5" (click)="openActionDialog('pagar')" mat-menu-item aria-label="Registrar pagamento">
            <span class="oa-am__icon oa-am__icon--pay" aria-hidden="true"><mat-icon>paid</mat-icon></span>
            <span>Registrar pagamento</span>
        </button>
    </ng-container>

    <mat-divider></mat-divider>
    <div class="oa-am__section" role="presentation">Mais</div>
    <button *ngIf="editProposal" (click)="edit()" mat-menu-item aria-label="Editar orçamento">
        <span class="oa-am__icon oa-am__icon--neutral" aria-hidden="true"><mat-icon>edit</mat-icon></span>
        <span>Editar</span>
    </button>
    <button (click)="duplicateProposal()" mat-menu-item aria-label="Duplicar orçamento">
        <span class="oa-am__icon oa-am__icon--neutral" aria-hidden="true"><mat-icon>content_copy</mat-icon></span>
        <span>Duplicar orçamento</span>
    </button>
    <button (click)="showLogsProposals()" mat-menu-item aria-label="Histórico de ações">
        <span class="oa-am__icon oa-am__icon--neutral" aria-hidden="true"><mat-icon>history</mat-icon></span>
        <span>Histórico de ações</span>
    </button>
    <button (click)="confirmDeleteProposal()" mat-menu-item class="oa-menu-item--danger" aria-label="Excluir orçamento">
        <span class="oa-am__icon oa-am__icon--danger" aria-hidden="true"><mat-icon>delete_outline</mat-icon></span>
        <span>Excluir</span>
    </button>
</mat-menu>

<mat-menu #contactsMenu="matMenu" class="oa-actions-menu">
    <button (click)="sendEmail(null)" mat-menu-item aria-label="enviar email">
        <mat-icon>email</mat-icon>
        <span>Todos os Contatos</span>
    </button>

    <button *ngIf="proposal?.client?.email" (click)="sendEmail(null, proposal?.client?.email)" mat-menu-item
        aria-label="enviar email">
        <mat-icon>star</mat-icon>
        <span>
            {{proposal?.client?.responsible ? proposal?.client.responsible : proposal?.client?.name}}
        </span>
    </button>

    <button *ngFor="let contact of proposal?.client?.contacts" (click)="sendEmail(contact)" mat-menu-item
        aria-label="aprovar">
        <mat-icon>alternate_email</mat-icon>
        <span>{{contact?.name}}</span>
    </button>
</mat-menu>

<mat-menu #phoneMenu="matMenu" class="oa-actions-menu">

    <button *ngIf="proposal?.client?.phone" mat-menu-item id="enviar-por-whatsapp"
        (click)="sendWhatsapp('whatsapp', proposal.client!.phone)">
        <mat-icon>star</mat-icon>
        <span>
            {{proposal?.client?.responsible ? proposal?.client.responsible : proposal?.client?.name}}
        </span>
    </button>

    <button mat-menu-item *ngIf="!proposal?.client?.phone" id="enviar-por-whatsapp">
        <mat-icon>contact_support</mat-icon>
        <span>Cliente não tem Número Cadastrado</span>
    </button>


    <ng-container *ngFor=" let contact of proposal?.client?.contacts">
        <div>
            <button mat-menu-item *ngIf="contact.phone" id="enviar-por-whatsapp"
                (click)="sendWhatsapp('whatsapp', contact.phone)">
                <mat-icon>phone</mat-icon>
                <span>{{contact.name}}</span>
            </button>
        </div>


    </ng-container>
</mat-menu>
<!-- ORCA-1965: botão "Enviar" da linha (orçamentos criados): só as formas de envio -->
<mat-menu #sendMenu="matMenu" class="oa-actions-menu" xPosition="before">
    <button [matMenuTriggerFor]="phoneMenu" mat-menu-item aria-label="Enviar por WhatsApp">
        <span class="oa-am__icon oa-am__icon--whatsapp" aria-hidden="true"><mat-icon>chat</mat-icon></span>
        <span>Enviar por WhatsApp</span>
    </button>
    <button *ngIf="proposal?.client?.email || proposal?.client?.contacts?.length"
        [matMenuTriggerFor]="contactsMenu" mat-menu-item aria-label="Enviar por e-mail">
        <span class="oa-am__icon oa-am__icon--email" aria-hidden="true"><mat-icon>mail</mat-icon></span>
        <span>Enviar por e-mail</span>
    </button>
    <button (click)="copy('link')" mat-menu-item aria-label="Copiar link do orçamento">
        <span class="oa-am__icon oa-am__icon--link" aria-hidden="true"><mat-icon>link</mat-icon></span>
        <span>Copiar link</span>
    </button>
</mat-menu>
